// ================================
// pages/legal/PrivacyPolicy.js
// ================================
import React from 'react';
import { Link } from 'react-router-dom';
import './Legal.css';

 const PrivacyPolicy = () => (
  <div className="legal-page">
    <div className="legal-container">
      <div className="legal-header">
        <Link to="/" className="legal-back">← Back</Link>
        <h1>Privacy Policy</h1>
        <p className="legal-date">Last updated: March 7, 2025 — SynexStudio</p>
      </div>

      <section>
        <h2>1. Introduction</h2>
        <p>SynexStudio ("we", "us", "our") operates RizzingBot. This Privacy Policy explains how we collect, use, and protect your personal data in accordance with the GDPR and French data protection law.</p>
        <p><strong>Data Controller:</strong> SynexStudio, Rouen, France — <a href="mailto:synexstudio76@gmail.com">synexstudio76@gmail.com</a></p>
      </section>

      <section>
        <h2>2. Data We Collect</h2>
        <h3>Account Data</h3>
        <ul>
          <li>Name and username</li>
          <li>Email address</li>
          <li>Password (stored as bcrypt hash — never in plain text)</li>
          <li>Google account information (if you use Google Sign-In)</li>
        </ul>
        <h3>Usage Data</h3>
        <ul>
          <li>Conversation content you enter into the Service</li>
          <li>Credits used and subscription status</li>
          <li>Feature usage logs (for billing and service improvement)</li>
        </ul>
        <h3>Payment Data</h3>
        <p>Payment information is processed directly by Stripe. We do not store your card details. We receive only transaction confirmation and subscription status.</p>
        <h3>Technical Data</h3>
        <ul>
          <li>IP address, browser type, access timestamps</li>
        </ul>
      </section>

      <section>
        <h2>3. How We Use Your Data</h2>
        <ul>
          <li>Provide and improve the Service</li>
          <li>Manage your account and subscriptions</li>
          <li>Process payments and issue invoices</li>
          <li>Send transactional emails (welcome, invoices, password reset)</li>
          <li>Detect fraud and ensure security</li>
        </ul>
        <p><strong>We do NOT sell your personal data. We do NOT use your conversation content for AI training.</strong></p>
      </section>

      <section>
        <h2>4. Legal Basis (GDPR)</h2>
        <ul>
          <li><strong>Contract performance:</strong> to provide the Service you signed up for</li>
          <li><strong>Legitimate interests:</strong> fraud prevention, security, service improvement</li>
          <li><strong>Legal obligation:</strong> invoicing, tax compliance</li>
        </ul>
      </section>

      <section>
        <h2>5. Data Retention</h2>
        <p>We retain your account data as long as your account is active. Invoices are retained for 10 years as required by French law. You may request deletion at any time.</p>
      </section>

      <section>
        <h2>6. Third-Party Services</h2>
        <ul>
          <li><strong>Stripe</strong> — payment processing</li>
          <li><strong>OpenAI</strong> — AI message generation</li>
          <li><strong>Brevo</strong> — transactional email delivery</li>
        </ul>
      </section>

      <section>
        <h2>7. Your Rights (GDPR)</h2>
        <p>You have the right to: access, rectify, erase, restrict, or port your personal data, and to lodge a complaint with the <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer">CNIL</a>.</p>
        <p>To exercise your rights: <a href="mailto:synexstudio76@gmail.com">synexstudio76@gmail.com</a></p>
      </section>

      <section>
        <h2>8. Cookies</h2>
        <p>We use strictly necessary session cookies for authentication only. No advertising or tracking cookies.</p>
      </section>

      <section>
        <h2>9. Contact</h2>
        <p><strong>Email:</strong> <a href="mailto:synexstudio76@gmail.com">synexstudio76@gmail.com</a></p>
        <p><strong>Company:</strong> SynexStudio — Rouen, France</p>
      </section>

      <div className="legal-footer">
        <Link to="/terms">Terms of Service</Link>
        <Link to="/refund">Refund Policy</Link>
        <Link to="/legal">Legal Notice</Link>
      </div>
    </div>
  </div>
);
export default PrivacyPolicy;